export var identificationTypeDataForm = {
    id: "",
    Description: "",
    Code: "",
    // MaxCharacter: 0,
    // MinCharacter: 0,
    // IsNumeric: false
};
